import { __awaiter } from 'tslib';
import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i2 from '@ngrx/store';
import { select } from '@ngrx/store';
import { BehaviorSubject, forkJoin } from 'rxjs';
import { map } from 'rxjs/internal/operators/map';
import { SetStateList, getStateList } from 'visa-store';
import * as CryptoJS from 'crypto-js';
import { take } from 'rxjs/operators';
import * as i1 from '@angular/common/http';

class ReferenceLibraryService {
    constructor(http, store) {
        this.http = http;
        this.store = store;
        this.onLoadResponseSubject = new BehaviorSubject(null);
        this.response = [];
        this.cacheArray = [];
        this.convertTransletedText = [];
        this.translationCache = new Map();
        this.translationQueue = new Set();
        this.isRequestInProgress = false;
        this.isArrayTranslationInProgress = false;
    }
    requestDataFromMultipleSources() {
        const response1 = this.http.get(`/referenceLibrary/ADDR`);
        const response2 = this.http.get(`/referenceLibrary/MARSTAT`);
        const response3 = this.http.get(`/referenceLibrary/PHON`);
        const response4 = this.http.get(`/referenceLibrary/EMLTYP`);
        const response5 = this.http.get(`/referenceLibrary/GENDER`);
        const response6 = this.http.get(`/referenceLibrary/TITL`);
        const response7 = this.http.get(`/referenceLibrary/MARSTAT`);
        const response8 = this.http.get(`/referenceLibrary/RACE`);
        const response9 = this.http.get(`/referenceLibrary/FAMRELTYP`);
        const response10 = this.http.get(`/referenceLibrary/CTZNACQRTYP`);
        const response11 = this.http.get(`/referenceLibrary/ETHNICITY`);
        return forkJoin([response1, response2, response3, response4, response5, response6, response7, response8, response9, response10, response11]);
    }
    getReferenceData(referenceCode) {
        return this.http.get(`/referenceLibrary/${referenceCode}`).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
        }));
    }
    getReferenceDocTypeData(refUrl) {
        return this.http.get(refUrl).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
        }));
    }
    getGroupReferenceData(groupReferenceCode) {
        return this.http.get(`/referenceLibrary/${groupReferenceCode}`).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
        }));
    }
    postReferenceData(payload) {
        return this.http.post(`/referenceLibrary/`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
        }));
    }
    getDataSource(groupName, code) {
        let url = '';
        if (groupName) {
            if (code) {
                url = `/${groupName.toUpperCase()}/elements?code=${code}`;
            }
            else {
                url = `/${groupName.toUpperCase()}/elements`;
            }
        }
        return this.http.get(`/vd/dataSource${url}`).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
        }));
    }
    getCurrencyCode() {
        var encryptedText = this.toEncrypt('FB_HIRING_CURRENCY');
        return this.http.get(`/vd/dataSource/${encryptedText}/elements`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getStatesFromApi(countryCode) {
        return this.http.get(`/countries/states?countryCode=${countryCode}`).pipe(map((response) => {
            if (response.status) {
                this.store.dispatch(new SetStateList({
                    countryCode: countryCode,
                    stateList: JSON.parse(JSON.stringify(response.data))
                }));
                return response.data;
            }
        }));
    }
    getStatesFromStore(countryCode) {
        return this.store.pipe(select(getStateList, { countryCode: countryCode }))
            .pipe(map((stateList) => {
            if (stateList) {
                return stateList;
            }
            else {
                return null;
            }
        }));
    }
    getReferenceDataWithoutAuthentication(referenceCode) {
        return this.http.get(`/referenceLibrary/${referenceCode}`).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
        }));
    }
    toEncrypt(_data) {
        var pharase = 'c63a423527b24f65';
        var data = _data;
        var key = CryptoJS.enc.Latin1.parse(pharase);
        var iv = CryptoJS.enc.Latin1.parse(pharase);
        var encrypted = CryptoJS.AES.encrypt(data, key, {
            iv: iv, mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.ZeroPadding
        }).toString();
        var e64 = CryptoJS.enc.Base64.parse(encrypted);
        var eHex = e64.toString(CryptoJS.enc.Hex);
        return this.encriptedData = eHex;
    }
    transletConversion() {
        return __awaiter(this, void 0, void 0, function* () {
            const currentLang = sessionStorage.getItem('currentLanguage') || 'en';
            const className = '.common-bene-class-for-translation';
            const textElements = document.querySelectorAll(className);
            const storedTranslation = sessionStorage.getItem('transletedLabel');
            const translatedData = storedTranslation ? JSON.parse(storedTranslation) : [];
            if (currentLang === 'en') {
                textElements.forEach(element => this.reverseTranslateElement(element, translatedData));
                return;
            }
            textElements.forEach(element => this.processElement(element, currentLang, translatedData));
            if (this.translationQueue.size > 0) {
                yield this.processQueue(currentLang);
            }
        });
    }
    processElement(element, currentLang, translatedData) {
        var _a, _b;
        const currentText = element.innerHTML.trim();
        if (!currentText)
            return;
        const matched = translatedData.find(res => res.labelname === currentText ||
            Object.values(res.translatedNames || {}).includes(currentText));
        const isAlreadyTranslated = ((_a = matched === null || matched === void 0 ? void 0 : matched.translatedNames) === null || _a === void 0 ? void 0 : _a[currentLang]) === currentText;
        if (isAlreadyTranslated)
            return;
        const baseLabel = (matched === null || matched === void 0 ? void 0 : matched.labelname) || currentText;
        const existing = translatedData.find(res => res.labelname === baseLabel);
        const translated = (_b = existing === null || existing === void 0 ? void 0 : existing.translatedNames) === null || _b === void 0 ? void 0 : _b[currentLang];
        if (translated) {
            element.innerHTML = translated;
        }
        else {
            this.translationQueue.add(baseLabel);
        }
    }
    reverseTranslateElement(element, translatedData) {
        const currentText = element.innerHTML.trim();
        if (!currentText)
            return;
        const found = translatedData.find(entry => Object.values(entry.translatedNames || {}).includes(currentText));
        if (found) {
            element.innerHTML = found.labelname;
        }
    }
    processQueue(currentLang) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isRequestInProgress || this.translationQueue.size === 0)
                return;
            this.isRequestInProgress = true;
            const storedTranslation = sessionStorage.getItem('transletedLabel');
            const translatedData = storedTranslation ? JSON.parse(storedTranslation) : [];
            this.translationQueue = new Set(Array.from(this.translationQueue).filter(label => {
                const existing = translatedData.find(res => { var _a; return res.labelname === label && ((_a = res.translatedNames) === null || _a === void 0 ? void 0 : _a[currentLang]); });
                return !existing;
            }));
            if (this.translationQueue.size === 0) {
                this.isRequestInProgress = false;
                return;
            }
            const labelList = Array.from(this.translationQueue).map(labelname => ({ labelname }));
            this.translationQueue.clear();
            try {
                const response = yield this.http
                    .post(`/translate/labels`, {
                    fromLanguage: 'en',
                    toLanguage: currentLang,
                    labelList
                })
                    .pipe(take(1))
                    .toPromise();
                if (response.status !== 200)
                    return;
                const updatedLabels = ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.labelList) || [];
                yield this.updateSessionStorageSafely(updatedLabels, currentLang);
                this.updateDOMElements(updatedLabels, currentLang);
            }
            catch (error) {
                console.error('Translation error:', error);
            }
            finally {
                this.isRequestInProgress = false;
                if (this.translationQueue.size > 0) {
                    this.processQueue(currentLang);
                }
            }
        });
    }
    updateSessionStorageSafely(newTranslations, currentLang) {
        return __awaiter(this, void 0, void 0, function* () {
            const key = 'transletedLabel';
            let stored = sessionStorage.getItem(key);
            let existing = stored ? JSON.parse(stored) : [];
            newTranslations.forEach(newItem => {
                const existingIndex = existing.findIndex(res => res.labelname === newItem.labelname);
                if (existingIndex !== -1) {
                    existing[existingIndex].translatedNames = Object.assign(Object.assign({}, (existing[existingIndex].translatedNames || {})), { [currentLang]: newItem.translatedName });
                }
                else {
                    existing.push({
                        labelname: newItem.labelname,
                        translatedNames: {
                            [currentLang]: newItem.translatedName
                        }
                    });
                }
            });
            sessionStorage.setItem(key, JSON.stringify(existing));
        });
    }
    updateDOMElements(updatedLabels, currentLang) {
        const storedTranslation = sessionStorage.getItem('transletedLabel');
        const translatedData = storedTranslation ? JSON.parse(storedTranslation) : [];
        updatedLabels.forEach((newItem) => {
            var _a;
            const labelname = newItem.labelname;
            const previousTranslation = (_a = translatedData.find(res => res.labelname === labelname)) === null || _a === void 0 ? void 0 : _a.translatedNames;
            document.querySelectorAll('.common-bene-class-for-translation').forEach((element) => {
                const currentText = element.innerHTML.trim();
                const isCurrentTextEnglish = currentText === labelname;
                const isCurrentTextPreviousTranslation = previousTranslation
                    ? Object.values(previousTranslation).includes(currentText)
                    : false;
                if (isCurrentTextEnglish || isCurrentTextPreviousTranslation) {
                    element.innerHTML = newItem.translatedName;
                }
            });
        });
    }
    translateArray(dataArray, key) {
        return __awaiter(this, void 0, void 0, function* () {
            const currentLang = sessionStorage.getItem('currentLanguage') || 'en';
            if (currentLang === 'en') {
                // No translation needed
                return Promise.resolve(dataArray.map(item => {
                    if (item.actualEnglishLabel) {
                        item[key] = item.actualEnglishLabel.trim();
                    }
                    else {
                        item.actualEnglishLabel = item[key];
                    }
                    return item;
                }));
            }
            // Avoid overlapping translation calls
            if (this.isRequestInProgress) {
                return new Promise(resolve => {
                    const checkInterval = setInterval(() => {
                        if (!this.isRequestInProgress) {
                            clearInterval(checkInterval);
                            resolve(this.translateArray(dataArray, key)); // Re-run for missing translations
                        }
                    }, 100);
                });
            }
            const storedTranslation = sessionStorage.getItem('transletedLabel');
            const translatedData = storedTranslation ? JSON.parse(storedTranslation) : [];
            const labelList = [];
            // 🧠 Step 1: Process input array and translate where possible
            const updatedArray = dataArray.map(item => {
                var _a;
                if (item[key]) {
                    const originalText = item.actualEnglishLabel || item[key];
                    const match = translatedData.find(res => res.labelname === originalText);
                    const translatedText = (_a = match === null || match === void 0 ? void 0 : match.translatedNames) === null || _a === void 0 ? void 0 : _a[currentLang];
                    if (!item.actualEnglishLabel) {
                        item.actualEnglishLabel = originalText;
                    }
                    if (translatedText) {
                        item[key] = translatedText;
                    }
                    else {
                        labelList.push({ labelname: originalText });
                    }
                }
                return item;
            });
            // ✅ Already translated everything
            if (labelList.length === 0)
                return Promise.resolve(updatedArray);
            this.isRequestInProgress = true;
            return new Promise(resolve => {
                this.http.post(`/translate/labels`, {
                    fromLanguage: 'en',
                    toLanguage: currentLang,
                    labelList
                }).pipe(take(1))
                    .subscribe((response) => __awaiter(this, void 0, void 0, function* () {
                    var _a, _b;
                    if (response.status !== 200) {
                        this.isRequestInProgress = false;
                        return resolve(updatedArray);
                    }
                    const newTranslations = ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.labelList) || [];
                    // 🧠 Step 2: Update sessionStorage inline (merge with existing)
                    newTranslations.forEach(newItem => {
                        const existingIndex = translatedData.findIndex(res => res.labelname === newItem.labelname);
                        if (existingIndex !== -1) {
                            translatedData[existingIndex].translatedNames = Object.assign(Object.assign({}, (translatedData[existingIndex].translatedNames || {})), { [currentLang]: newItem.translatedName });
                        }
                        else {
                            translatedData.push({
                                labelname: newItem.labelname,
                                translatedNames: {
                                    [currentLang]: newItem.translatedName
                                }
                            });
                        }
                        // 🧠 Step 3: Update the array with new translations
                        updatedArray.forEach(item => {
                            if (item.actualEnglishLabel === newItem.labelname) {
                                item[key] = newItem.translatedName;
                            }
                        });
                    });
                    sessionStorage.setItem('transletedLabel', JSON.stringify(translatedData));
                    this.isRequestInProgress = false;
                    if (((_b = this.translationQueue) === null || _b === void 0 ? void 0 : _b.size) > 0) {
                        this.processQueue(currentLang);
                    }
                    resolve(updatedArray);
                }));
            });
        });
    }
}
ReferenceLibraryService.ɵfac = function ReferenceLibraryService_Factory(t) { return new (t || ReferenceLibraryService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.Store)); };
ReferenceLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: ReferenceLibraryService, factory: ReferenceLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReferenceLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: i2.Store }]; }, null); })();

/*
 * Public API Surface of reference-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ReferenceLibraryService };
//# sourceMappingURL=reference-library.js.map
